// extracted by mini-css-extract-plugin
export var dateLabel = "_2h-0";
export var dateLabelError = "_2h-1";
export var fullWidth = "_2h-2";
export var smaller = "_2h-3";